import React from "react";

/** Full-bleed isometric apartment illustration for mobile auth screens */
const LoginMobileHero = () => (
  <div className="login-apartment-hero">
    <svg
      className="login-apartment-hero__svg"
      viewBox="0 0 390 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="aptSky" x1="0" y1="0" x2="390" y2="180" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0a3552" />
          <stop offset="0.5" stopColor="#1565a0" />
          <stop offset="0.85" stopColor="#2a9db8" />
          <stop offset="1" stopColor="#c9954a" />
        </linearGradient>
        <linearGradient id="aptGlass" x1="0" y1="0" x2="0" y2="1">
          <stop stopColor="#5eb3e8" />
          <stop offset="1" stopColor="#1a5f8f" />
        </linearGradient>
        <linearGradient id="aptGlassDark" x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="#3589be" />
          <stop offset="1" stopColor="#0f3d5e" />
        </linearGradient>
        <linearGradient id="aptGold" x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="#c9a054" />
          <stop offset="1" stopColor="#f2db9a" />
        </linearGradient>
      </defs>

      <rect width="390" height="180" fill="url(#aptSky)" />

      <ellipse cx="310" cy="36" rx="48" ry="48" fill="#ffd98a" opacity="0.4" />
      <ellipse cx="60" cy="42" rx="36" ry="12" fill="#fff" opacity="0.15" />

      <path d="M40 155 L40 88 L68 74 L96 88 L96 155 Z" fill="url(#aptGlassDark)" />
      <path d="M40 88 L68 74 L96 88 L68 102 Z" fill="url(#aptGold)" />
      <rect x="50" y="96" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="63" y="96" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.55" />
      <rect x="50" y="112" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.65" />
      <rect x="63" y="112" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.95" />
      <rect x="50" y="128" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.75" />
      <rect x="63" y="128" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.5" />

      <path d="M96 155 L96 68 L134 48 L172 68 L172 155 Z" fill="url(#aptGlass)" />
      <path d="M96 68 L134 48 L172 68 L134 88 Z" fill="url(#aptGold)" />
      <rect x="108" y="78" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="122" y="78" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.5" />
      <rect x="136" y="78" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.8" />
      <rect x="108" y="96" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.55" />
      <rect x="122" y="96" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.95" />
      <rect x="136" y="96" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.6" />
      <rect x="108" y="114" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.85" />
      <rect x="122" y="114" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.45" />
      <rect x="136" y="114" width="10" height="11" rx="1" fill="#ffe9a8" opacity="0.9" />

      <path d="M158 155 L158 44 L203 22 L248 44 L248 155 Z" fill="url(#aptGlassDark)" />
      <path d="M158 44 L203 22 L248 44 L203 66 Z" fill="url(#aptGold)" />
      <line x1="203" y1="22" x2="203" y2="8" stroke="#fff" strokeWidth="2" strokeLinecap="round" opacity="0.85" />
      <circle cx="203" cy="6" r="3" fill="#ffd978" />
      <rect x="170" y="54" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.95" />
      <rect x="187" y="54" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.65" />
      <rect x="204" y="54" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="221" y="54" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.5" />
      <rect x="170" y="74" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.7" />
      <rect x="187" y="74" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.95" />
      <rect x="204" y="74" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.55" />
      <rect x="221" y="74" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.85" />
      <rect x="170" y="94" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.6" />
      <rect x="187" y="94" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="204" y="94" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.75" />
      <rect x="221" y="94" width="11" height="12" rx="1" fill="#ffe9a8" opacity="0.45" />

      <path d="M234 155 L234 72 L268 56 L302 72 L302 155 Z" fill="url(#aptGlass)" />
      <path d="M234 72 L268 56 L302 72 L268 88 Z" fill="url(#aptGold)" />
      <rect x="244" y="82" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.85" />
      <rect x="257" y="82" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.5" />
      <rect x="270" y="82" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="244" y="98" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.45" />
      <rect x="257" y="98" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.85" />
      <rect x="270" y="98" width="9" height="10" rx="1" fill="#ffe9a8" opacity="0.6" />

      <path d="M302 155 L302 90 L326 78 L350 90 L350 155 Z" fill="url(#aptGlassDark)" />
      <path d="M302 90 L326 78 L350 90 L326 102 Z" fill="url(#aptGold)" />
      <rect x="311" y="100" width="8" height="9" rx="1" fill="#ffe9a8" opacity="0.8" />
      <rect x="323" y="100" width="8" height="9" rx="1" fill="#ffe9a8" opacity="0.5" />
      <rect x="311" y="114" width="8" height="9" rx="1" fill="#ffe9a8" opacity="0.9" />
      <rect x="323" y="114" width="8" height="9" rx="1" fill="#ffe9a8" opacity="0.55" />
    </svg>
    <div className="login-apartment-hero__fade" aria-hidden="true" />
  </div>
);

export default LoginMobileHero;
